import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {FormattingUrlDialog} from './formattingUrlDialog';

/*
 * Props.
 */

interface FormattingLinkDialogProps {
  link: string | undefined;
  onLinkChange: HandlerOf<string | undefined>;
  onRequestClose: Handler;
  selectedText?: string;
}

/*
 * Component.
 */

export const FormattingLinkDialog: FC<FormattingLinkDialogProps> = ({
  link,
  onLinkChange,
  onRequestClose,
  selectedText,
}) => (
  <FormattingUrlDialog
    title={renderTitle(!link)}
    url={link || selectedText}
    onUrlChange={onLinkChange}
    onRequestClose={onRequestClose}
  />
);

function renderTitle(isInserting: boolean) {
  if (isInserting) {
    return <Trans id="formatting-insertlink">Insert a link</Trans>;
  }

  return <Trans id="formatting-updatelink">Update a link</Trans>;
}
